/* The centred modal used for help, settings and API keys. */

.wrap {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: grid;
  place-items: center;
  padding: 16px;
  opacity: 0;
  /* Visibility, not just opacity: a closed panel must leave the
     accessibility tree and the tab order, not merely stop being painted.
     It is switched at once on the way in and held until the fade has
     finished on the way out. */
  visibility: hidden;
  transition:
    opacity 0.38s var(--ease),
    visibility 0s linear 0.38s;
  pointer-events: none;
}

/* A real button, so clicking away is reachable from the keyboard too. */
.backdrop {
  position: absolute;
  inset: 0;
  cursor: default;
  background: rgba(12, 34, 25, 0.2);
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
}

.wrap.shown {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transition:
    opacity 0.38s var(--ease),
    visibility 0s;
}

.modal {
  width: min(560px, 100%);
  max-height: min(82vh, 720px);
  border-radius: var(--r-xl);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: var(--shadow-3);
  transform: scale(0.94) translateY(12px);
  transition: transform 0.46s var(--ease);
}

.modal {
  position: relative;
}

.wrap.shown .modal {
  transform: none;
}

.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 16px 12px 24px;
  flex: none;
}

.head h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.03em;
}

.body {
  overflow-y: auto;
  padding: 0 24px calc(24px + var(--safe-b));
  font-size: 14.5px;
  line-height: 1.55;
  color: var(--ink-2);
  letter-spacing: -0.01em;
}

.body h3 {
  color: var(--ink);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin: 22px 0 10px;
}

.body p {
  margin: 0 0 12px;
}

.body code {
  font-family: var(--mono);
  font-size: 12.5px;
  background: rgba(11, 31, 23, 0.055);
  padding: 2px 6px;
  border-radius: 6px;
  color: var(--ink);
}

@media (max-width: 620px) {
  .modal {
    border-radius: var(--r-lg);
  }

  .body {
    padding-left: 18px;
    padding-right: 18px;
  }

  .head {
    padding-left: 18px;
  }
}
